<template>
  <footer
    class="footer"
    data-animation="footer"
  >
    <section class="footer__headline">
      <AppEyelet
        :data="{
          content: data.eyelet,
        }"
        :isAnimated="false"
        data-item="eyelet"
      />
      <AppLine class="footer__line" :isAnimated="false" data-item="line"/>
      <AppTitle
        class="c-title--dark"
        :data="{
          content: data.title,
        }"
        :isAnimated="false"
        data-item="title"
      />
    </section>
    <section class="footer__content">
      <AppLine class="footer__line" :isAnimated="false" data-item="line"/>
      <div data-item="content">
        <AppEyelet
          class="content__title"
          :data="{
            content: 'About us'
          }"
          :isAnimated="false"
        />
        Awwwards is the most visited digital design awards platform in the world.
        <br><br>
        Every year we hold conferences in iconic cities across the globe including
          New York, Amsterdam, Paris, London and Los Angeles, to discover trends and
          new technologies, network and unveil the secrets of the Internet.
        <br><br>
        <a
          href="https://www.awwwards.com/"
          target="_blank"
          rel="noopener"
          @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
          @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
        >Visit <bdi>awwwards.com.</bdi></a>
      </div>
      <AppLine class="footer__line" :isAnimated="false" data-item="line"/>
    </section>
    <section class="footer__contact">
      <AppLine class="footer__line u-hidden--until-ipadP" :isAnimated="false" data-item="line"/>
      <div class="footer__subcont" data-item="content">
        <div class="footer__social">
          <AppEyelet
            class="content__title"
            :data="{
              content: 'Follow Us'
            }"
            :isAnimated="false"
          />
          <ul>
            <li>
              <a
                href="https://www.facebook.com/awwwards/"
                @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                target="_blak"
                rel="noopener"
              >Facebook</a>
            </li>
            <li>
              <a
                href="https://twitter.com/awwwards"
                @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                target="_blak"
                rel="noopener"
              >Twitter</a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/awwwards/"
                @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                target="_blak"
                rel="noopener"
              >Instagram</a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UCYWGYef22gx8PaXZMLHAQsw"
                @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                target="_blak"
                rel="noopener"
              >YouTube</a>
            </li>
          </ul>
        </div>
        <div class="footer__info">
          <AppEyelet
            class="content__title"
            :data="{
              content: 'Contact'
            }"
            :isAnimated="false"
          />
          <a
            href="mailto:sarah@awwwards.com"
            @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
            @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
            target="_blank"
            rel="noopener"
          >
            Write to us
          </a>
          <br>
          <a
            href="mailto:sarah@awwwards.com"
            @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
            @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
            target="_blank"
            rel="noopener"
          >
            Be a sponsor
          </a>
        </div>
      </div>
      <AppLine class="footer__line" :isAnimated="false" data-item="line"/>
    </section>
    <section class="footer__legal" data-item="legal">
      <div class="content__col">
        Made by <a
          href="https://adoratorio.studio"
          @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
          @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
          target="_blank"
          rel="noopener"
        >Adoratorio Studio</a>
      </div>
      <div class="content__col">
        <a
          href="/pdf/code-of-conduct.pdf"
          @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
          @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
          target="_blank"
          rel="noopener"
        >Code of conduct</a> . <a
          :href="`/pdf/sponsorship-plans-${$route.params.city}.pdf`"
          @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
          @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
          target="_blank"
          rel="noopener"
        >Sponsorship plans</a>
      </div>
    </section>
  </footer>
</template>

<script>
import AppLine from '@/components/AppLine.vue';
import AppEyelet from '@/components/AppEyelet.vue';
import AppTitle from '@/components/AppTitle.vue';

import data from '@/assets/data/contents/footer.json';

export default {
  name: 'AppFooter',
  components: {
    AppLine,
    AppEyelet,
    AppTitle,
  },
  data() {
    return {
      data,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: $unit-vh * 8;
  display: grid;
  grid-template-columns: repeat(13, 1fr);

  line-height: 1.5;

  font-size: 16px;

  @include mq($from: dm) {
    font-size: 20px;
  }

  @include mq($from: dxl) {
    font-size: 24px;
  }

  @include mq($and: $is-not-touch-device) {
    a {
      transition: color .4s $outCirc;

      bdi {
        transition: color .4s $outCirc;
      }
    }
    a:hover {
      color: var(--color-headline-dark);

      bdi {
        color: var(--color-headline-dark);
      }

      @at-root [data-city="toronto"] & {
        color: var(--color-cursor);

        bdi {
          color: var(--color-cursor);
        }
      }
    }
  }

  .content__title {
    color: var(--color-headline-light);
    margin-bottom: 25px;
  }

  @include mq($until: ipadP) {
    &__line {
      margin: $unit-vh * 3 0;
    }

    line-height: 1.8;
  }

  @include mq($until: ipadL) {
    &__line {
      margin: $unit-vh * 1.5 0;
    }

    line-height: 1.5;
  }

  @include mq(ipadP) {
    margin-top: $unit-vh * 4;
  }

  @include mq(ds) {
    margin-top: $unit-vh * 12;
  }

  .footer__headline,
  .footer__legal {
    display: grid;
    grid-column: 1 / -1;

    @include mq(ipadP) {
      grid-column: 1 / -1;
    }

    @include mq(ipadL) {
      grid-column: 1 / 11;
    }
  }

  .footer__content {
    grid-column: 1 / -1;

    bdi {
      color: var(--color-headline-light);
    }

    @include mq(ipadP) {
      grid-column: 1 / 7;
    }

    @include mq(ipadL) {
      grid-column: 1 / 6;
    }
  }

  .footer__contact {
    position: relative;
    grid-column: 1 / -1;

    @include mq(ipadP) {
      grid-column: 8 / -1;
    }

    @include mq(ipadL) {
      grid-column: 7 / 11;
    }

    .footer__subcont {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      width: 100%;
    }

    .footer__line {
      &:last-child {
        position: relative;

        @include mq(ipadP) {
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }

    .footer__social {
      grid-column: 1 / 2;

      @include mq($from: dm) {
        grid-column: 1 / 3;
      }
    }

    .footer__info {
      grid-column: 3 / -1;
      justify-self: end;
    }
  }

  .footer__legal {
    grid-template-columns: repeat(13, 1fr);

    @include mq(ipadL) {
      grid-template-columns: repeat(10, 1fr);
    }

    .content__col {
      &:first-child {
        grid-column: 1 / -1;
      }

      &:last-child {
        grid-column: 1 / -1;
      }

      @include mq(ipadP) {
        &:first-child {
          grid-column: 1 / 8;
        }

        &:last-child {
          grid-column: 8 / -1;
        }
      }

      @include mq(ipadL) {
        &:first-child {
          grid-column: 1 / 6;
        }

        &:last-child {
          grid-column: 7 / 12;
        }
      }
    }
  }
}
</style>
